// Centralized color management for HennabyAnjali website
// Change colors here to update the entire website theme

const colors = {
  background: '#D9E4C3',
  highlight: '#BFAF8D',
  primary: '#8B7355',
  secondary: '#A89968',
  text: {
    dark: '#2C2416',
    medium: '#4A3F2E',
    light: '#6B5D47'
  },
  white: '#FFFFFF',
  accent: '#C5B896',
  hover: '#9D8A6C'
};

export default colors;